/**
 * @file Skins de munitions (cosmetiques, un equipe par categorie d'arme) : achat en gemmes / Rubis, equipement, lecture du style actif.
 */
import type { WeaponBehavior } from '@shared/enums';
import { fail, okVoid } from '@shared/types';
import type { Result } from '@shared/types';
import type { AmmoStyle } from '@config/types';
import type { SimContext } from '../Context';

export class AmmoSkinService {
  constructor(private readonly ctx: SimContext) {}

  owns(id: string): boolean {
    return this.ctx.data.ammoSkins.owned.includes(id);
  }

  /** Style visuel actif d'une categorie (lu par le rendu). */
  styleOf(behavior: WeaponBehavior): AmmoStyle {
    const id = this.ctx.data.ammoSkins.equipped[behavior];
    return this.ctx.index.ammoSkin(id).style;
  }

  buy(id: string): Result {
    const ctx = this.ctx;
    const skin = ctx.config.ammoSkins.find((s) => s.id === id);
    if (!skin) return fail('unknownId');
    if (this.owns(id)) return fail('alreadyOwned');
    if (!ctx.services.unlocks.isFeatureUnlocked('skins')) return fail('locked');
    return ctx.tx.purchase(skin.cost, `ammo:${id}`, () => {
      ctx.data.ammoSkins.owned.push(id);
      ctx.bus.emit('AmmoSkinBought', { id });
      return okVoid;
    });
  }

  /** Equipe un skin possede pour SA categorie. */
  equip(id: string): Result {
    const ctx = this.ctx;
    const skin = ctx.config.ammoSkins.find((s) => s.id === id);
    if (!skin) return fail('unknownId');
    if (!this.owns(id)) return fail('notOwned');
    ctx.data.ammoSkins.equipped[skin.behavior] = id;
    ctx.bus.emit('AmmoSkinEquipped', { behavior: skin.behavior, id });
    return okVoid;
  }
}
